import { APP_INITIALIZER, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppInit } from './app-init.action';
import { AppInitEffects } from './app-init.effect';

@NgModule({
  imports: [EffectsModule.forFeature([AppInitEffects])],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (store: Store) => () => {
        store.dispatch(AppInit());
      },
      deps: [Store],
      multi: true,
    },
  ],
})
export class AppInitModule {}
